/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum VacInternalItemType {
    Company = 'company',
    Tenant = 'tenant',
    User = 'user',
    SubscriptionPlan = 'subscriptionPlan',
    Location = 'location',
    SubscriptionPlanToCompany = 'subscriptionPlanToCompany',
    Alarm = 'alarm',
    BackupPolicy = 'backupPolicy',
    DiscoveryRule = 'discoveryRule',
    ResellerOwner = 'resellerOwner',
    CloudAgent = 'cloudAgent',
    Client = 'client',
    Reseller = 'reseller',
    VeeamOne = 'veeamOne',
    VB365 = 'vB365'
};

